<template>
    <div class="h-100">
        <md-card-media>
            <img
                :alt="card.name + ' Banner'"
                :src="card.banner_url || '/img/event-banner-default.jpg'"
            />
        </md-card-media>
        <md-card-content class="event-card px-0 py-0">
            <div class="wrap-event-info d-flex flex-row px-4 py-3">
                <div class="event-desc">
                    <h2 class="pb-1 mb-0">{{card.name}}</h2>
                    <div class="wrap-organizer">
                        <div>
                            by
                            <h6 class="event-organizer">{{card.organizer_name}}</h6>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-auto px-4 pb-2">
                <hr class="separator" />
                <div class="m-0 event-topics">
                    <span v-for="(topic, index) in card.topics" :key="topic.id">
                        {{topic.name}}
                        <span
                            v-if="card.topics.length > index+1"
                            class="text-muted mx-2"
                        >•</span>
                    </span>
                </div>
            </div>
        </md-card-content>
    </div>
</template>
<script>
import { format, parseISO, isThisYear, isAfter } from "date-fns";
export default {
    name: "ChallengeCard",
    props: ["card"],
    computed: {
        conf() {
            return this.$store.getters.conf;
        },
        formattedDate() {
            return this.card.start_datetime
                ? format(parseISO(this.card.start_datetime), "MMMdd")
                : "";
        },
        dateYear() {
            if (isThisYear(parseISO(this.card.start_datetime))) {
                return null;
            } else {
                return this.card.start_datetime
                    ? format(parseISO(this.card.start_datetime), "yyyy")
                    : "";
            }
        },
        isChallengeOpen() {
            return this.card.end_datetime
                ? isAfter(parseISO(this.card.end_datetime), new Date())
                : true;
        }
    }
};
</script>
<style lang="scss">
@import "@/assets/scss/_common.scss";
.md-card {
    // max-width: 376px;
    border-radius: 5px;
    // margin: 20px;
    height: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    .md-card-content {
        color: $palette-blue !important;
        position: relative;
    }
    h2 {
        font-size: 22px !important;
    }
}
.dot {
    height: 3px;
    width: 3px;
    background: #a4a4a4;
    border-radius: 50%;
    margin: 0 10px;
}
.md-card-media img {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    min-height: 180px;
}

.md-card-media {
    img {
        height: 180px;
        object-fit: cover;
    }
    .notify-flag {
        position: absolute;
        top: 15px;
        right: -6px;
        font-weight: 700;
        background: #f8f8f8;
        border-radius: 5px;
        background-color: $palette-orange;
        color: #fff;
        font-size: 12px;
    }

    .event-type {
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: #fff;
        font-size: 14px;
        color: $palette-blue;
        font-weight: 600;
        padding: 5px 15px 5px 15px;
        border-top-right-radius: 5px;
        text-transform: capitalize;
    }
}

.event-card {
    text-align: left;
    min-height: 180px;
    display: flex;
    flex-direction: column;
    height: calc(100% - 180px);
    h3 {
        font-size: 1rem;
        text-transform: uppercase;
        font-weight: bold;
    }

    h3.upcoming {
        color: #4a90e2;
    }
    h3.past {
        color: gray;
    }
    h4 {
        font-size: 16px;
        font-weight: 500;
    }
    h2 {
        font-size: 20px;
        font-weight: 600;
    }

    .event-months {
        font-size: 16px;
        color: $palette-orange;
    }

    .event-dates {
        font-size: 26px;
        font-weight: 500;
    }
    .wrap-organizer {
        font-size: 12px;
        .event-organizer {
            font-weight: 700;
            display: inline;
            font-size: 12px;
        }
    }

    .event-state-closed {
        font-size: 16px;
        color: $palette-blue;
        opacity: 0.55;
    }

    .event-state-open {
        font-size: 16px;
        color: $palette-orange;
    }

    .separator {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .event-topics {
        font-size: 12px;
    }
}
</style>
